import type { Appointments } from "@/lib/appointments"

import type { BookingSummaryProps } from "@/components/Booking/BookingSummary"
import { SummaryBlock } from "@/components/Booking/SummaryBlock"

import { UserIcon } from "@/constants/icons"

type AppointmentTypeProps = {
  appointmentType?: Appointments.AppointmentDetails[`appointmentType`]
  practitioner?: Appointments.AppointmentDetails[`practitioner`]
  style: BookingSummaryProps[`style`]
}

export const AppointmentType = ({
  appointmentType,
  practitioner,
  style,
}: AppointmentTypeProps) => {
  return appointmentType ? (
    <SummaryBlock style={style} title={`Appointment`} icon={UserIcon}>
      <p>
        {appointmentType}
        {practitioner ? ` with ${practitioner}` : null}
      </p>
    </SummaryBlock>
  ) : null
}
